import { cardTitle, title } from "assets/jss/material-kit-react.js";
import imagesStyle from "assets/jss/material-kit-react/imagesStyles.js";

const adsStyle = {

  h2Title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "80px",
    minHeight: "32px",
    textDecoration: "none",
    fontSize:"1.5rem"
  },
  section: {
    padding: "70px 0px 20px 0",
    textAlign: "center"
  },
  bannerSection: {
    padding: "20px 0px 20px 0",
    textAlign: "center"
  },
  ATag: {
    color: "#555",
    "&:hover":{
      color: '#888',
    }
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  ...imagesStyle,
  itemGrid: {
    marginLeft: "auto",
    marginRight: "auto"
  },
  cardTitle,
  smallTitle: {
    color: "#6c757d"
  },
  new_description: {
    textAlign:"justify",
    color: "#999",
    fontSize:"12px"
  },
  description: {
    textAlign:"justify",
    color: "#999"
  },
  justifyCenter: {
    justifyContent: "center !important"
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999"
  },
  margin5: {
    margin: "5px"
  },
  imageSize2:{
    maxWidth: "180px !important"
  },
  ShowAll:{
    margin: "50px auto 20px auto",
    textAlign:"center"
  },
};

export default adsStyle;
